/**
 * Built-in Jira fields that use fieldName as the API field identifier.
 * Custom Jira fields use jiraFieldId (display name) as the API field identifier.
 */
export const BUILT_IN_JIRA_FIELDS = new Set([
  "issuetype",
  "status",
  "assignee",
  "created",
  "key",
  "summary",
  "description",
  "duedate",
]);
